import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function MainMenuButton(props) {
  const {isOpen, ...otherProps} = props;
  return (
    <div className="ndx-MainMenuButton" {...otherProps}>
      <div className="ndx-MainMenuButton-top-bun" />
      <div className="ndx-MainMenuButton-meat" />
      <div className="ndx-MainMenuButton-bottom-bun" />
      <div className="ndx-MainMenuButton-text">{isOpen ? 'Close' : 'Menu'}</div>
    </div>
  );
}

const propTypes = {
  isOpen: PropTypes.bool
};

MainMenuButton.propTypes = propTypes;
